

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../../constants";
import { fetchData } from "../../../../helpers";

// ADDCONTACTUSSECTIONWITHAPPROVAL
// ADDCONTACTUSSECTIONWITHAPPROVAL


const ADDCONTACTUSSECTIONWITHAPPROVAL= createAsyncThunk(
  "addContactUsSectionWithApproval/addContactUsSectionWithApproval",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const addContactUsSectionWithApprovalSlice = createSlice({
  name: "addContactUsSectionWithApprovalSlice",
  initialState: {
    addContactUsSectionWithApproval: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfaddContactUsSectionWithApproval: (state) => {
        state.addContactUsSectionWithApproval.loading = false
        state.addContactUsSectionWithApproval.error = false
        state.addContactUsSectionWithApproval.data = []
        state.addContactUsSectionWithApproval.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(ADDCONTACTUSSECTIONWITHAPPROVAL.fulfilled, (state, action) => {
      state.addContactUsSectionWithApproval = {
        ...state.addContactUsSectionWithApproval,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDCONTACTUSSECTIONWITHAPPROVAL.pending, (state, action) => {
      state.addContactUsSectionWithApproval = {
        ...state.addContactUsSectionWithApproval,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(ADDCONTACTUSSECTIONWITHAPPROVAL.rejected, (state, action) => {
      state.addContactUsSectionWithApproval = {
        ...state.addContactUsSectionWithApproval,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const addContactUsSectionWithApprovalAction = {
    ADDCONTACTUSSECTIONWITHAPPROVAL,
};

export { addContactUsSectionWithApprovalAction };
export default addContactUsSectionWithApprovalSlice.reducer;
export const {setInitialStateOfaddContactUsSectionWithApproval} = addContactUsSectionWithApprovalSlice.actions
